<template>
  <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
    <img class="h-12 w-12 rounded-full inline-block mr-3" v-if="fanpage.attributes['avatar']" :src="fanpage.attributes['avatar']">
    {{fanpage.attributes['name']}}
  </td>
  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500 ">
    <span v-if="fanpage.attributes['instagram-business-account']">
      <img class="h-12 w-12 rounded-full inline-block mr-3" :src="fanpage.attributes['instagram-business-account']['data']['attributes']['avatar']">
      {{fanpage.attributes['instagram-business-account']['data']['attributes']['name']}}
    </span>
    <span v-else>
      <span class="inline-flex rounded-full px-2 text-xs font-semibold leading-5 text-red-800 bg-red-100">
        <span>{{ $t('fanpages.notConnected') }}</span>
      </span>
    </span>
  </td>
  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{fanpage.attributes['fanpage-id']}}</td>
  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
    <Datetime v-bind:date="this.fanpage.attributes['last-updated-at']" />
  </td>
  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
    <span class="inline-flex rounded-full px-2 text-xs font-semibold leading-5" :class="{'text-red-800 bg-red-100': fanpage.attributes['has-graph-api-errors'], 'text-green-800 bg-green-100 ': !fanpage.attributes['has-graph-api-errors']}">
      <span v-if="fanpage.attributes['has-graph-api-errors']">
        {{ $t('fanpages.permissionError') }}
      </span>
      <span v-else>{{ $t('fanpages.integrated') }}</span>
    </span>
    <span class="text-sm" v-if="fanpage.attributes['has-graph-api-errors']">
      {{ $t('fanpages.reconnect') }}
    </span>
  </td>
  <td class="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
    <button v-on:click="askRemove" type="button" class="inline-flex items-center px-2.5 py-1.5 border border-gray-300 shadow-sm text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
      <TrashIcon class="-ml-0.5 mr-2 h-4 w-4" aria-hidden="true" />
      {{ $t('actions.remove') }}
    </button>
    <FanpageDelete v-if="showRemove" v-bind:fanpage="fanpage" v-on:delete-finished-event="removeFanpage" />
  </td>
</template>


<script>
import FanpageDelete from './FanpageDelete';
import Datetime from '../building_blocks/DateTime.vue'
import { TrashIcon } from '@heroicons/vue/outline'

export default {
  name: 'FanpageListItem',
  props: ['fanpage'],
  emits: ['delete-event'],
  components: {
    FanpageDelete,
    Datetime,
    //
    TrashIcon,
  },
  methods: {
    askRemove() {
      this.showRemove = true;
    },
    removeFanpage() {
      this.showRemove = false;
      this.$emit('delete-event');
    },
  },
  data() {
    return {
      showRemove: false,
    }
  },
}
</script>
